import { useIsMutating, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { fetchBooking } from "PFApp/booking/services/api";
import { Booking } from "PFCore/types";
import { QueryOptions } from "PFTypes";
import { useEffect, useState } from "react";

import { bookingKeys } from "./query_keys";
import { getBookingDeleteMutationKey } from "./use_booking_delete";

export const useBooking = (bookingId?: number, options: QueryOptions<Booking, AxiosError> = {}) => {
  const [disabled, setDisabled] = useState(false);

  const isDeleting = !!useIsMutating({ mutationKey: getBookingDeleteMutationKey(bookingId) });

  useEffect(() => {
    if (isDeleting) {
      setDisabled(true);
    }
  }, [isDeleting]);

  return useQuery<Booking, AxiosError>({
    queryKey: bookingKeys.single(bookingId),
    queryFn: () => fetchBooking(bookingId),
    retry: false,
    ...options,
    enabled: !disabled && (options.enabled ?? true)
  });
};
